import { jsx, Fragment } from 'react/jsx-runtime';
import { motion, AnimatePresence } from 'framer-motion';
import React__default, { useRef, useState, useEffect } from 'react';
import { styled } from 'styled-components';

const Container = styled(motion.div).withConfig({
  displayName: "AnimateChangeInHeight__Container",
  componentId: "sc-de329bc3-0"
})([
  `overflow:hidden;flex-shrink:0;`
]);
const AnimateChangeInHeightContainer = ({ children, className, duration = 0.15 }) => {
  const containerRef = useRef(null);
  const [height, setHeight] = useState("auto");
  useEffect(() => {
    if (containerRef.current) {
      const resizeObserver = new ResizeObserver((entries) => {
        const observedHeight = entries[0].contentRect.height;
        setHeight(observedHeight);
      });
      resizeObserver.observe(containerRef.current);
      return () => {
        resizeObserver.disconnect();
      };
    }
  }, []);
  React__default.useEffect(() => {
    if (!children) {
      setHeight(0);
    }
  }, [
    children
  ]);
  return /* @__PURE__ */ jsx(Container, {
    className,
    style: {
      height
    },
    initial: {
      height
    },
    animate: {
      height
    },
    transition: {
      duration,
      ease: "linear"
    },
    children: /* @__PURE__ */ jsx("div", {
      ref: containerRef,
      children: /* @__PURE__ */ jsx(AnimatePresence, {
        children
      })
    })
  });
};
const AnimateChangeInHeight = ({ children, disabled = false, ...props }) => {
  if (disabled) {
    return /* @__PURE__ */ jsx(Fragment, {
      children
    });
  }
  return /* @__PURE__ */ jsx(AnimateChangeInHeightContainer, {
    ...props,
    children
  });
};

export { AnimateChangeInHeight };
//# sourceMappingURL=AnimateChangeInHeight.js.map
